import React from 'react';
import CategoryList from '../components/CategoryList';

const Home = ({ selectedCategory, setSelectedCategory }) => {
  return (
    <div>
      <div className="container mt-4">
        <CategoryList
          category={selectedCategory.name}
          endpoint={selectedCategory.endpoint}
        />
      </div>
    </div>
  );
};

export default Home;
